"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm$lot;
  var _vm = this,
    _c = _vm._self._c;
  return _c("b-modal", {
    attrs: {
      active: _vm.isModalActive,
      width: 720,
      "has-modal-card": "",
      "trap-focus": "",
      scroll: "keep"
    },
    on: {
      close: _vm.handleClose
    }
  }, [_c("form", {
    staticClass: "modal-card",
    on: {
      submit: function submit($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments);
      }
    }
  }, [_c("header", {
    staticClass: "modal-card-head card-head"
  }, [_c("div", [_c("p", {
    staticClass: "modal-card-title"
  }, [_vm._v("\n          Gerenciar Lote\n        ")]), _vm._v(" "), (_vm$lot = _vm.lot) !== null && _vm$lot !== void 0 && _vm$lot.code ? _c("p", {
    staticClass: "modal-subtitle"
  }, [_vm._v("\n          Lote: " + _vm._s(_vm.lot.code) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c("div", {
    staticClass: "header-actions"
  }, [_c("b-button", {
    staticClass: "delete-btn",
    attrs: {
      type: "is-danger",
      outlined: ""
    },
    on: {
      click: _vm.handleDeleteLot
    }
  }, [_vm._v("\n          Remover Lote\n        ")]), _vm._v(" "), _c("button", {
    staticClass: "delete",
    attrs: {
      type: "button"
    },
    on: {
      click: _vm.handleClose
    }
  })], 1)]), _vm._v(" "), _c("section", {
    staticClass: "modal-card-body"
  }, [_c("div", {
    staticClass: "form-section"
  }, [_c("div", {
    staticClass: "form-row"
  }, [_c("b-field", {
    staticClass: "form-field",
    attrs: {
      label: "Nome"
    }
  }, [_c("b-input", {
    attrs: {
      placeholder: "Nome do lote",
      disabled: ""
    },
    model: {
      value: _vm.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c("b-field", {
    staticClass: "form-field",
    attrs: {
      label: "Data de criação"
    }
  }, [_c("b-datepicker", {
    attrs: {
      placeholder: "Selecione a data",
      icon: "calendar-today",
      required: ""
    },
    model: {
      value: _vm.form.createdAt,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "createdAt", $$v);
      },
      expression: "form.createdAt"
    }
  })], 1)], 1), _vm._v(" "), _c("SectionRowInventories", {
    attrs: {
      "show-quantity": true,
      label: "",
      "item-title": "Local",
      "add-button-label": "Adicionar local",
      "add-first-label": "Adicionar primeiro local",
      "empty-message": "Nenhum local adicionado.",
      "min-items": 1,
      "max-items": 10,
      editable: false
    },
    model: {
      value: _vm.form.inventories,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "inventories", $$v);
      },
      expression: "form.inventories"
    }
  })], 1), _vm._v(" "), _vm.operations.length ? _c("div", {
    staticClass: "form-section"
  }, [_c("div", {
    staticClass: "plant-nursery-table table-items-list"
  }, [_c("b-table", {
    attrs: {
      data: _vm.operations,
      loading: _vm.isLoadingOperations,
      striped: true,
      hoverable: true,
      "mobile-cards": true
    },
    on: {
      "update:loading": function updateLoading($event) {
        _vm.isLoadingOperations = $event;
      }
    }
  }, [_c("b-table-column", {
    attrs: {
      field: "senderLot",
      label: "Lote origem"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        var _props$row$senderLot;
        return [_vm._v("\n              " + _vm._s(((_props$row$senderLot = props.row.senderLot) === null || _props$row$senderLot === void 0 ? void 0 : _props$row$senderLot.code) || "--") + "\n            ")];
      }
    }], null, false, 2686012509)
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "type",
      label: "Operação"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n              " + _vm._s(_vm.formatOperationType(props.row.type)) + "\n            ")];
      }
    }], null, false, 946999274)
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "totalQuantity",
      label: "Quantidade"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n              " + _vm._s(_vm.formatQuantity(props.row.totalQuantity)) + "\n            ")];
      }
    }], null, false, 3296647613)
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "occurredAt",
      label: "Data"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n              " + _vm._s(_vm.formatDate(props.row.occurredAt || props.row.createdAt)) + "\n            ")];
      }
    }], null, false, 1861742228)
  })], 1)], 1)]) : _vm._e()]), _vm._v(" "), _c("footer", {
    staticClass: "modal-card-foot"
  }, [_c("b-button", {
    staticClass: "plant-nursery-primary-btn",
    attrs: {
      type: "is-primary",
      "native-type": "submit",
      loading: _vm.isSaving,
      disabled: _vm.isSaving
    }
  }, [_vm._v("\n        Salvar alterações\n      ")]), _vm._v(" "), _c("b-button", {
    attrs: {
      type: "is-text"
    },
    on: {
      click: _vm.handleClose
    }
  }, [_vm._v("\n        Cancelar\n      ")])], 1)])]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;